// extracted by extract-css-chunks-webpack-plugin
module.exports = {"stores":"_9Sunq","storesIE11":"KUMA1"};